import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import { getResidentsList } from './api';
import type {
  GetResidentsListPayload,
  GetResidentsListResponse,
  ResidentData,
} from './types';

export const ResidentsListControlGate = createGate<ResidentData>();

const fxGetResidentsList = createEffect<
  GetResidentsListPayload,
  GetResidentsListResponse,
  Error
>().use(getResidentsList);

export const residentsListQuery = createQuery({
  effect: fxGetResidentsList,
  mapData: ({ result }) =>
    Array.isArray(result?.residents)
      ? result.residents.map((item) => ({
          id: item?.resident_guid,
          residentId: item?.resident_id,
          label: item?.title ?? item?.fio ?? '',
        }))
      : [],
});

cache(residentsListQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

/** Запрос данных */
sample({
  clock: ResidentsListControlGate.state,
  source: ResidentsListControlGate.status,
  filter: (status) => Boolean(status),
  fn: (_, data) => {
    const payload: GetResidentsListPayload = {
      with_archived: Number(Boolean(data.withArchived)),
    };

    if ((data.residentType as string[]).length > 0) {
      payload.resident_type = data.residentType as string[];
    }

    return payload;
  },
  target: residentsListQuery.start,
});
